module.exports = __webpack_public_path__ + "img/fold.515a26e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fold.png
// module id = 5dhR
// module chunks = 4